<template>
  <div>

    <template>
      <h1 class="subheading text-xs-center">Create your Loyalty Program</h1>
      <p class="subheading text-xs-center">Start by choosing the type of program you would like to create</p>
    </template>

    <v-container fluid grid-list-xl>
      <v-layout row>
        <v-flex xs4>
          <v-container fluid grid-list-xl>
            <v-layout row>
              <v-flex xs12>
                <v-card class="current--status">
                  <h2 class="main-title text-xs-center">Points Program</h2>
                  <v-container fluid grid-list-lg>
                    <v-layout row>
                      <v-flex xs12 text-xs-center>
                        <v-btn text @click="uuid = null; dataForm = true" class="special-program-btn">Create Program</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
        <v-flex xs4>
          <v-container fluid grid-list-xl>
            <v-layout row>
              <v-flex xs12>
                <v-card class="current--status">
                  <h2 class="main-title text-xs-center">Tier Program</h2>
                  <v-container fluid grid-list-lg>
                    <v-layout row>
                      <v-flex xs12 text-xs-center>
                        <v-btn text @click="uuid = null;" class="special-program-btn" disabled>Create Program</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
        <v-flex xs4>
          <v-container fluid grid-list-xl>
            <v-layout row>
              <v-flex xs12>
                <v-card class="current--status">
                  <h2 class="main-title text-xs-center">Perks Program</h2>
                  <v-container fluid grid-list-lg>
                    <v-layout row>
                      <v-flex xs12 text-xs-center>
                        <v-btn text @click="uuid = null;" class="special-program-btn" disabled>Create Program</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs4>
          <v-container fluid grid-list-xl>
            <v-layout row>
              <v-flex xs12>
                <v-card class="current--status">
                  <h2 class="main-title text-xs-center">CSR Program</h2>
                  <v-container fluid grid-list-lg>
                    <v-layout row>
                      <v-flex xs12 text-xs-center>
                        <v-btn text @click="uuid = null;" class="special-program-btn" disabled>Create Program</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
        <v-flex xs4>
          <v-container fluid grid-list-xl>
            <v-layout row>
              <v-flex xs12>
                <v-card class="current--status">
                  <h2 class="main-title text-xs-center">Engagement Rewards</h2>
                  <v-container fluid grid-list-lg>
                    <v-layout row>
                      <v-flex xs12 text-xs-center>
                        <v-btn text @click="uuid = null;" class="special-program-btn" disabled>Create Program</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
        <v-flex xs4>
          <v-container fluid grid-list-xl>
            <v-layout row>
              <v-flex xs12>
                <v-card class="current--status">
                  <h2 class="main-title text-xs-center">Staff Discounts</h2>
                  <v-container fluid grid-list-lg>
                    <v-layout row>
                      <v-flex xs12 text-xs-center>
                        <v-btn text @click="uuid = null;" class="special-program-btn" disabled>Create Program</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>



    <v-dialog
            persistent
            :width="settings.dialog_width || 650"
            :fullscreen="$vuetify.breakpoint.xsOnly"
            v-model="dataForm"
            :dataForm="dataForm"
            @keydown.esc="dataForm = false"
    >
      <data-form
              v-if="dataForm"
              v-on:data-list-events="dataListEvents = $event"
              :model="model"
              :uuid="uuid"
      ></data-form>
    </v-dialog>

  </div>
</template>
<script>
  export default {
    data() {
      return {
        model: 'Platform\\Models\\Program',
        uuid: false,
        plan: '',
        dataListEvents: null,
        dataForm: false,
        settings : {
          dialog_width: false
        }
      }
    },
    watch: {
      dataListEvents () {
        if (this.dataListEvents.closeDialog) {
          console.log('comes here close Dialog');
          this.dataForm = false
        }
        if (this.dataListEvents.reload) {
          console.log('comes here reload');
          this.reloadData()
        }
      }
    },
    methods: {
    }
  }
</script>